import { WIDGET_URL, LAUNCHER_URL, MATERIAL_ICON_URL, POWEREDBY_URL } from './config/config'
import { BOT_BUTTON, BOT_CENTER, BOT_LEFT, BOT_MAIN, BOT_MESSAGE, CONTAINED, CONTAINED_THEME, CONTAINER_LESS_THEME, EB_BOT_FAIL, LAUNCHER_BUTTON_CLOSE, LAUNCHER_CLOSE } from './constants'
import { setUpHeader, theme } from './setuptest'
import { storageFactory } from './storage/storage'
import { botLaunchButton, shouldPop } from './utils/cta'
import { addClass, createElement, createIframe, createStyleLink, getElementById, setAttribute } from './utils/dom'
import { getIsOnline } from './utils/isOnline'
import { Choices, detectMob, hexToRgbA, iframeID, isEmpty, isMobile, stringifyJson } from './utils/utils'

let isOnline = true
let POST_DATA_SENT = {}

window.addEventListener('online', () => {
  getIsOnline().then((online) => { isOnline = online }).catch(() => { isOnline = true })
})

window.addEventListener('offline', () => {
  getIsOnline().then((online) => { isOnline = online }).catch(() => { isOnline = true })
})

const styleLinkUrl = LAUNCHER_URL + 'bot.css'
const botURL = WIDGET_URL + 'bots'

let poweredByText = 'By EnquiryBot'
let poweredByUrl = POWEREDBY_URL
let PREVIOUS_BOT = ''

const storage = storageFactory()

const Launcher = () => {
  const botId = '5f5b3b3b7b3b3b3b3b3b3b3b'
  const referrerUrl = document.referrer
  const launchButton = createElement('div')
  const botWidget = createElement('div')
  botWidget.id = 'botwidget'
  addClass(botWidget, 'bot-eb-widget')
  addClass(botWidget, 'bot-hide')
  var iframe = createIframe(iframeID(botId), 'bot-iframe')
  setAttribute(iframe, 'data-position', 'center')
  addClass(iframe, BOT_LEFT)
  iframe.style.height = '100%'
  iframe.style.width = '100%'
  iframe.style.borderWidth = '0px'
  const styleLink = createStyleLink(styleLinkUrl)
  const materialLink = createStyleLink(MATERIAL_ICON_URL)
  const containedHeader = document.createElement('div')
  const containedAvatar = document.createElement('div')
  const containedTitle = document.createElement('div')
  const containedclose = document.createElement('i')
  const poweredMain = document.createElement('div')
  const powered = document.createElement('a')
  const poweredMobile = document.createElement('div')
  const closeButton = document.createElement('i')

  const triggerPostMessage = (data) => {
    getElementById(iframeID(botId)).contentWindow.postMessage(stringifyJson(data), WIDGET_URL)
  }

  const getContainer = (theme) => {
    if (isEmpty(theme)) return CONTAINER_LESS_THEME
    const style = theme.style
    if (theme.placement === 3) return CONTAINER_LESS_THEME
    if (style === 'Container Less') return CONTAINER_LESS_THEME
    if (style === 'Contained') return CONTAINED_THEME
  }

  const entryPoint = `?entry=${encodeURIComponent(document.location.href)}`

  const onCompleted = () => {
    setTimeout(() => {
      if (JSON.parse(storage.getItem('botOpen')) && launchButton.classList.contains('bot-active')) {
        launchButton.click()
      }
      if (JSON.parse(storage.getItem('botCenterOpen')) && botWidget.classList.contains('bot-show')) {
        closeButton.click()
      }
    }, 1000)
  }

  const botInitialize = () => {
    let BUTTON_BOT = null
    let ACTIVE_BUTTON = null

    const themeData = theme

    const currentSessionId = botId

    if (themeData.custom_branding) {
      poweredByText = `${themeData.powered_by}`
      poweredByUrl = themeData.website_url
    }

    const currentUrl = document.location.href

    let postData = {}

    if (!document.getElementById(iframeID(botId))) {
      if (!iframe.src) {
        iframe.src = `${botURL}/${botId}/${currentSessionId}/${getContainer(themeData)}${entryPoint}`
      }
      setUpHeader(botId)
      const placement = Choices.BotPlacement[themeData.placement]

      if (themeData.style === CONTAINED) {
        if (placement !== BOT_CENTER) {
          botWidget.style.removeProperty('background')
          addClass(botWidget, 'contained')
          if (!themeData.is_rounded) {
            addClass(botWidget, 'edged')
            addClass(containedHeader, 'edged')
          }
          addClass(botWidget, placement)
          addClass(launchButton, 'contained')
          botWidget.appendChild(containedHeader)
        }
        if (themeData.bottom_spacing && !isMobile()) {
          botWidget.style.bottom = `calc(${themeData.bottom_spacing}px + 60px)`
        }
        if (themeData.side_spacing && !isMobile()) {
          if (themeData.placement === 1) {
            botWidget.style.left = `${themeData.side_spacing}px`
          }
          if (themeData.placement === 2) {
            botWidget.style.right = `${themeData.side_spacing}px`
          }
        }
      }
      if (themeData.style !== CONTAINED && themeData.style !== 'Contained') {
        if (themeData.side_spacing && !isMobile()) {
          if (themeData.placement === 1) {
            botWidget.style.paddingLeft = `${themeData.side_spacing}px`
            botWidget.style.width = `calc(${themeData.side_spacing}px + 400px)`
          } else if (themeData.placement === 2) {
            botWidget.style.paddingRight = `${themeData.side_spacing}px`
            botWidget.style.width = `calc(${themeData.side_spacing}px + 400px)`
          }
        }
      }

      const containedPowered = () => {
        const poweredContainedMain = createElement('div')
        addClass(poweredContainedMain, 'containedpowered')
        if (themeData.style === 'Contained') {
          addClass(poweredContainedMain, 'contained')
        }
        const poweredContained = createElement('a')
        addClass(poweredContained, 'power')
        setAttribute(poweredContained, 'href', poweredByUrl)
        setAttribute(poweredContained, 'target', '_blank')
        setAttribute(poweredContained, 'rel', 'noopener noreferrer')
        poweredContained.innerText = poweredByText
        poweredContainedMain.appendChild(poweredContained)
        botWidget.insertAdjacentElement('beforeend', poweredContainedMain)
      }

      window.addEventListener('message', e => {
        if (e.data) {
          if (e.data.bot_status === EB_BOT_FAIL) {
            getElementById(iframeID(botId)).contentWindow.postMessage(stringifyJson(POST_DATA_SENT), '*')
          }
          if (e.data.action === LAUNCHER_CLOSE) {
            if (e.data.data.exit) {
              onCompleted()
            }
          }
          if (e.data.action === LAUNCHER_BUTTON_CLOSE) {
            if (e.data.data.exit) {
              onCompleted()
            }
          }
        }
      })

      const poweredContainer = (element, placement) => {
        poweredMain.classList.add('powered')
        if (themeData.style === 'Contained') {
          poweredMain.classList.add('contained')
        }
        powered.href = poweredByUrl
        if (placement === 'bot-center') {
          poweredMain.classList.add('bot-right')
          powered.classList.add('bot-right')
          poweredMobile.classList.add('bot-right')
        } else {
          poweredMain.classList.add(placement)
          powered.classList.add(placement)
          poweredMobile.classList.add(placement)
        }
        powered.classList.add('power')
        poweredMobile.classList.add('power')
        powered.target = '_blank'
        powered.rel = 'noopener noreferrer'
        powered.innerText = poweredByText
        poweredMobile.innerText = poweredByText
        // not displaying the hyperlink for mobile version
        if (window.innerWidth <= 427) {
          poweredMain.appendChild(poweredMobile)
        } else {
          poweredMain.appendChild(powered)
        }
        element.insertAdjacentElement('beforeend', poweredMain)
      }

      containedclose.onclick = (event) => {
        launchButton.click()
      }

      closeButton.onclick = (event) => {
        BUTTON_BOT = null
        ACTIVE_BUTTON = null
        storage.setItem('botCenterOpen', false)
        botWidget.classList.toggle('bot-show')
        setTimeout(() => {
          botWidget.style.removeProperty('background')
        }, 100)
        if (!botWidget.classList.contains('bot-show')) {
          setTimeout(() => {
            botWidget.classList.add('bot-hide')
            closeButton.classList.add('bot-hide')
            if (
              themeData.style !== CONTAINED &&
              themeData.style !== 'Contained'
            ) {
              if (themeData.side_spacing && !isMobile()) {
                if (themeData.placement === 1) {
                  botWidget.style.paddingLeft = `${themeData.side_spacing}px`
                  botWidget.style.width = `calc(${themeData.side_spacing}px + 400px)`
                } else if (themeData.placement === 2) {
                  botWidget.style.paddingRight = `${themeData.side_spacing}px`
                  botWidget.style.width = `calc(${themeData.side_spacing}px + 400px)`
                }
              }
            } else {
              if (themeData.bottom_spacing && !isMobile()) {
                botWidget.style.bottom = `calc(${themeData.bottom_spacing}px + 60px)`
              }
              if (themeData.side_spacing && !isMobile()) {
                if (themeData.placement === 1) {
                  botWidget.style.left = `${themeData.side_spacing}px`
                }
                if (themeData.placement === 2) {
                  botWidget.style.right = `${themeData.side_spacing}px`
                }
              }
            }
          }, 200)
        }
      }

      const widgetScreenStyle = (themeData) => {
        const gradientStart = themeData.desktop_side_screen_gradient_start_colour
        const gradientEnd = themeData.desktop_side_screen_gradient_end_colour
        const gradientTransparency = themeData.desktop_side_screen_transparency
        const mobileBg = themeData.mobile_background_colour
        const mobileBgTransparency = themeData.mobile_full_screen_transparency
        if (themeData.style !== 'Contained') {
          if (gradientStart && gradientEnd && mobileBg) {
            let gradientAngle = themeData.side_screen_gradient_angle
            // placement is left reverse the gradient
            if (themeData.placement === 1) {
              gradientAngle = `-${gradientAngle}`
            }
            if (isMobile()) {
              botWidget.style.background = hexToRgbA(mobileBg, mobileBgTransparency)
            } else {
              botWidget.style.backgroundImage = `linear-gradient(${gradientAngle}deg, ${hexToRgbA(gradientStart, gradientTransparency)} 1%, ${hexToRgbA(gradientEnd, 99)} 100%)`
            }
          }
        }
      }

      const launchButtonClick = (event) => {
        BUTTON_BOT = null
        ACTIVE_BUTTON = null
        botWidget.classList.remove('bot-hide')
        botWidget.classList.toggle('bot-show')
        launchButton.classList.toggle('bot-active')
        const isBotActive = launchButton.classList.contains('bot-active')

        // appending header for container because it was removed when center bot was opened
        if (themeData.style === 'Contained') {
          if (!document.getElementById('contained-header')) {
            botWidget.insertBefore(containedHeader, botWidget.firstChild)
          }
        }
        widgetScreenStyle(themeData)
        iframe.setAttribute('name', 'bot-iframe')
        if (isBotActive) {
          storage.setItem('botOpen', true)
        } else {
          storage.setItem('botOpen', false)
        }
        iframe.src = `${botURL}/${botId}/${currentSessionId}/${getContainer(themeData)}${entryPoint}`
        postData = {
          action: BOT_MESSAGE,
          data: {
            name: iframe.name,
            entry_point: currentUrl,
            theme: themeData,
            referrerUrl,
            active: isBotActive
          }
        }
        POST_DATA_SENT = postData
        iframe.onload = () => {
          if (isBotActive) {
            triggerPostMessage({ ready: true })
          }
          setTimeout(() => {
            if (isBotActive) {
              triggerPostMessage(postData)
            }
          }, 100)
        }
        if (!document.getElementById(iframeID(botId))) {
          botWidget.append(iframe)
          if (themeData.style === CONTAINED) {
            if (window.innerWidth >= 426) {
              if (themeData.eb_branding || themeData.custom_branding) {
                containedPowered()
              }
            }
          }
        } else {
          const iframeElement = document.getElementById(iframeID(botId))
          if (PREVIOUS_BOT === BOT_BUTTON) {
            iframeElement.remove()
            botWidget.append(iframe)
          }
        }
        PREVIOUS_BOT = BOT_MAIN
        if (botWidget.classList.contains(BOT_CENTER)) {
          botWidget.classList.remove(BOT_CENTER)
          botWidget.classList.add(placement)
        }

        const logo = document.getElementById('bot-logo')
        const close = document.getElementById('bot-close')
        if (isBotActive) {
          setTimeout(() => {
            poweredMain.classList.add('bot-active')
          }, 2000)
          close.classList.remove('bot-cover')
          logo.classList.add('bot-cover')
        } else {
          poweredMain.classList.remove('bot-active')
          close.classList.add('bot-cover')
          logo.classList.remove('bot-cover')
        }
        if (!isBotActive) {
          setTimeout(() => {
            botWidget.classList.add('bot-hide')
          }, 100)
        }
      }

      launchButton.onclick = (event) => {
        if (!isOnline && !launchButton.classList.contains('bot-active')) {
          return
        }
        launchButtonClick(event)
      }

      botWidget.classList.add(placement)
      botWidget.appendChild(closeButton)
      if (placement === 'bot-center') {
        launchButton.classList.add('bot-right')
      } else {
        launchButton.classList.add(placement)
      }
      document.head.appendChild(materialLink)
      document.head.append(styleLink)

      if (!document.getElementById('eb-bot-trigger')) {
        // if bot is deactivated dont append the trigger button

        botLaunchButton(launchButton, themeData)
        if (themeData.eb_branding || themeData.custom_branding) {
          poweredContainer(launchButton, placement)
        }

        if (!document.getElementById('botwidget')) {
          document.body.appendChild(botWidget)
        }
      }

      styleLink.onload = () => {
        const isMobile = detectMob()
        setTimeout(() => {
          // bot-center close button
          closeButton.classList.add('bot-center-close')
          if (iframe.name === 'bot-iframe') {
            closeButton.classList.add('bot-hide')
          }
          closeButton.classList.add('material-icons')
          closeButton.innerHTML = 'highlight_off'
          // bot contained Header style
          containedHeader.classList.add('bot-header')
          containedHeader.setAttribute('id', 'contained-header')
          containedAvatar.classList.add('bot-avatar')
          containedTitle.classList.add('bot-title')
          containedTitle.innerHTML = 'humblegrape'
          containedclose.innerHTML = 'close'
          containedclose.classList.add('bot-contained-close')
          containedclose.classList.add('material-icons')
          containedHeader.appendChild(containedAvatar)
          containedHeader.appendChild(containedTitle)
          containedHeader.appendChild(containedclose)
          if (!document.getElementById('eb-bot-trigger')) {
            // if bot is deactivated dont append the trigger button
            if (document.getElementById('botwidget')) {
              document.body.insertBefore(launchButton, botWidget)
            }
          }
          setTimeout(() => {
            if (!isMobile) {
              if (themeData.show_bot_on_desktop && themeData.automatically_open_the_bot_on_desktop) {
                if (!document.getElementById(iframeID(botId))) {
                  if (JSON.parse(storage.getItem('botOpen')) === null) {
                    launchButton.click()
                  } else if (JSON.parse(storage.getItem('botOpen'))) {
                    launchButton.click()
                  }
                }
              }
            }
            if (isMobile) {
              if (themeData.show_bot_on_mobile && themeData.automatically_open_the_bot_on_mobile) {
                if (!document.getElementById(iframeID(botId))) {
                  if (JSON.parse(storage.getItem('botOpen')) === null) {
                    launchButton.click()
                  } else if (JSON.parse(storage.getItem('botOpen'))) {
                    launchButton.click()
                  }
                }
              }
            }
          }, parseInt(isMobile ? themeData.automatically_open_the_bot_on_mobile_delay : themeData.automatically_open_the_bot_on_desktop_delay) * 1000)
          setTimeout(() => {
            shouldPop(themeData, launchButton)
          }, parseInt(parseInt(isMobile ? themeData.automatically_open_the_bot_on_mobile_delay : themeData.automatically_open_the_bot_on_desktop_delay) * 1000) / 3)
        }, 1000)
      }
    }
  }

  botInitialize()
}

Launcher()
